import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAlert,{staticClass:"mt-2 message-bar",attrs:{"transition":"fade-transition","type":_vm.mappedType,"dismissible":_vm.isErrorMessage},on:{"input":_vm.onAlertInput},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},[_vm._v(" "+_vm._s(_vm.currentMessage)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }